import { css } from "@emotion/react";
import styled from "@emotion/styled";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { BaseLink } from "shared/components/common/base-link";
import { transientOptions, ZIndexLayer } from "shared/lib/styles";

import IconBookmark from "./icon-bookmark.svg";
import IconClose from "./icon-close.svg";

export const Container = styled.div`
  position: sticky;
  inset-block-start: 0;
  z-index: 1;

  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-block-end: 24px;
  margin-inline: 18px;
  padding-block: 16px;

  background: #222834;
  border-block-end: 1px solid rgba(255, 255, 255, 0.6);
`;

export const EditionContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const EditionText = styled.div`
  margin-inline-end: 4px;

  color: #ffffff;
  font-size: 14px;
  line-height: 16px;

  opacity: 0.7;
`;

export const Edition = styled(Button)`
  padding: 0;

  color: #ffffff;
  font-size: 14px;
  line-height: 16px;
  text-transform: capitalize;

  cursor: pointer;

  span {
    margin-inline-start: 8px;
  }
`;

export const EditionMenu = styled(Menu)`
  z-index: ${ZIndexLayer.EditionInvitation};
`;

export const EditionMenuItem = styled(MenuItem)`
  min-block-size: auto;
  padding-block: 6px;
  padding-inline: 16px;

  color: rgb(111, 111, 111);
  font-size: 16px;
  line-height: 19.2px;

  &:hover {
    background-color: transparent;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

type StyledIconBookmarkProps = {
  $isNew: boolean;
};
export const StyledIconBookmark = styled(IconBookmark, {
  ...transientOptions,
})<StyledIconBookmarkProps>`
  position: relative;

  cursor: pointer;

  ${props =>
    props.$isNew
      ? css`
          &:after {
            position: absolute;
            inset-block-start: -2px;
            inset-inline-end: -1.5px;
            content: "";
            z-index: 1;

            inline-size: 4px;
            block-size: 4px;

            border-radius: 50%;

            background: #eb4254;
          }
        `
      : null}
`;

export const StyledMynewsLink = styled(BaseLink)`
  line-height: 0;
`;

export const StyledIconClose = styled(IconClose)`
  cursor: pointer;
`;
